<template>
    <div class="movie-swiper component">
      <swiper
        class="swiper"
        :options="swiperOption"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        ref="movieSwiper">
        <swiper-slide v-for="(movie, idx) in movies" :key="idx"><img :src="movie.image"/></swiper-slide>
      </swiper>
    </div>
  </template>
  
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'MovieSwiper',
  props: {
    movies: { type: Array }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 4,
        slideToClickedSlide: true,
        spaceBetween: 20,
        updateOnWindowResize: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false
        },
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  methods: {
    onSwiper (swiper) {
  
    },
    onSlideChange () {
      if (this.swiper) {
        this.$emit('slideChange', this.swiper.$swiper.activeIndex)
      }
    }
  },
  mounted () {
    const movieSwiper = this.$refs.movieSwiper
    this.swiper = movieSwiper
  }
}
</script>
  
  <style lang="scss" scoped>
    .movie-swiper {
      width: 100%;
      padding-top: 12.5px;
      padding-bottom: 12.5px;
  
      .swiper {
        width: 100%;
        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-weight: bold;
          font-size: 12px;
          background-color: transparent;
          background-position: center;
          background-size: cover;
  
          img {
            width: 100%;
          }
        }
      }
    }
  </style>
